import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/blood-product";

export const pagingBloodProduct = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getBloodProductById = (bloodProductId) => axios.get(API_PATH + "/get-by-id/" + bloodProductId);

export const saveOrUpdateBloodProduct = bloodProduct => axios.post(API_PATH + "/save", bloodProduct);

export const deleteBloodProduct = bloodProductId => axios.delete(API_PATH + '/mark-delete/' + bloodProductId);

export const saveBloodProductSyncStore = (result) => axios.post(API_PATH + "/sync-blood-product-from-store", result);
